import { useState, useCallback } from 'react';

const useUpdate = (baseUrl, options = {}) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const updateData = useCallback(
    async (id, payload) => {
      setIsLoading(true);
      try {
        const urlWithId = `${baseUrl}/${id}`;
        console.log("Updating at:", urlWithId);

        const response = await fetch(urlWithId, {
          ...options,
          method: 'PUT', 
          // headers: {
          //   'Content-Type': 'application/json',
          //   ...(options.headers || {}),
          // },
          // body: JSON.stringify(payload),
          headers: {
            ...(payload instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
            ...(options.headers || {}),
          },
          body: payload instanceof FormData ? payload : JSON.stringify(payload),
        });

        const result = await response.json();
        console.log('Update response:', result);

        if (!response.ok) {
          throw new Error(result.message || 'Failed to update the resource');
        }

        setData(result);
        setError(null);
      } catch (err) {
        setError(err.message || 'Something went wrong during update');
      } finally {
        setIsLoading(false);
      }
    },
    [baseUrl, options]
  );

  return { data, error, isLoading, updateData };
};

export default useUpdate;
